import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-64fd0579"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "text-muted"
}
const _hoisted_2 = {
  key: 1,
  class: "event-payouts"
}
const _hoisted_3 = { class: "text-muted" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_tooltip = _resolveComponent("el-tooltip")!

  return (!_ctx.paidEvents.length)
    ? (_openBlock(), _createElementBlock("span", _hoisted_1, "—"))
    : (_openBlock(), _createElementBlock("dl", _hoisted_2, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.paidEvents, (e) => {
          return (_openBlock(), _createElementBlock(_Fragment, {
            key: e.name
          }, [
            _createVNode(_component_el_tooltip, {
              content: e.name,
              placement: "top"
            }, {
              default: _withCtx(() => [
                _createElementVNode("dt", _hoisted_3, _toDisplayString(e.name), 1)
              ]),
              _: 2
            }, 1032, ["content"]),
            _createElementVNode("dd", null, _toDisplayString(_ctx.formatPayout(e)), 1)
          ], 64))
        }), 128))
      ]))
}